import { Modal } from 'react-bootstrap';
import { Trash2 } from 'lucide-react';
import PropTypes from 'prop-types';

const DeleteConfirmationModal = ({
  show = false,
  onClose,
  onConfirm,
  itemType = '',
  itemName,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="modern-delete-modal"
    >
      <Modal.Body>
        <div className="trash-icon-container">
          <Trash2 />
        </div>
        <h3>Delete {itemType}</h3>
        <p>
          Are you sure you want to delete {itemName}? This action cannot be
          undone.
        </p>
        <div className="modal-actions">
          <button
            onClick={onClose}
            className="btn-cancel"
            data-testid="cancel-delete-modal-btn"
            aria-label="Cancel deletion"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="btn-delete"
            data-testid="confirm-delete-modal-btn"
            aria-label={`Confirm delete ${itemType}`}
          >
            Delete {itemType}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  itemType: PropTypes.string,
  itemName: PropTypes.string.isRequired,
};

export default DeleteConfirmationModal;
